exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "blockquote{color:var(--ds-color-london-5);font-family:var(--ds-type-system-serif);font-size:var(--ds-type-scale-1);font-style:italic;font-weight:400;line-height:var(--ds-type-leading-lower)}", ""]);

// exports
